<template>
  <div oncontextmenu="return false">
    <br/>
    <h2>{{ videoTitle }}</h2>
    <br/>
    <video-js
      id="mainvideo"
      class="video-js vjs-default-skin"
      controls
      autoplay
      :width="videoWidth" :height="videoHeight"
      style="margin-left:auto;margin-right:auto;"
      oncontextmenu="return false"
      @ended="completed"
    >
    </video-js>
  </div>
</template>

<script>
import videojs from 'video.js'

export default {
  name: 'VideoPanel',

  props: {
    videoTitle: {
      type: String,
      required: false,
      default: ''
    },
    availableFrom: {
      required: false
    },
    videoUrl: {
      type: String,
      required: true
    },
    videoType: {
      type: String,
      required: true
    },
    expirationTime: {
      required: false
    },
    returnURL: {
      type: String,
      required: false,
      default: ''
    },
    videoWidth: {
      type: Number,
      required: false,
      default: 960
    },
    videoHeight: {
      type: Number,
      required: false,
      default: 540
    },
    reportStateFrequency: { // How many seconds between report state events. Unlikely you'll want to change this.
      type: Number,
      required: false,
      default: 1
    }
  },

  methods: {
    completed: function () {
      this.$emit('completed')
    },
    playpause: function () {
      if (this.player.paused()) {
        this.player.play()
      } else {
        this.player.pause()
      }
    },
    skip: function (skipSeconds) {
      this.player.currentTime(this.player.currentTime() + skipSeconds)
      if (skipSeconds > 0) {
        this.$emit('reportSkip', 'forward')
      } else {
        this.$emit('reportSkip', 'backward')
      }
    },
    toggleFullScreen () {
      if (this.player.isFullscreen()) {
        this.player.exitFullscreen()
      } else {
        this.player.requestFullscreen()
      }
    }
  },

  computed: {
    statusMessage: function () {
      const available = new Date(this.availableFrom)
      let message = this.videoTitle + ' begins at ' + available.toString()
      message += '<br/> Time to start' + this.timeToStart
      return 'Waiting for video to start. ' + message
    },

    startTime: function () {
      return this.startTime
    },

    timeToStart: function () {
      return Math.floor((new Date() - this.availableFrom) / 1000 / 60) + ' minutes'
    },

    videoData: function () {
      return {
        techOrder: [
          'html5',
          'youtube'
        ],
        sources: [
          {
            type: this.videoType,
            src: this.videoUrl
          }
        ],
        html5: {
          hls: {
            withCredentials: true
          }
        },
        youtube: {
          iv_load_policy: 3, // This disables annotations in the displayed video. Probably desirable.
          modestbranding: 1, // This minimizes the YouTube branding on the page. It's not possible to get rid of it entirely.
          rel: 0, // This used to disable Related Videos pop-ups. Now the best you can do is confine them to the same channel so keep this at 0 to limit to SANS videos
          showinfo: 0 // This used to disable info show. Now it only hides thumbnails. Might as well keep.
        }
      }
    }
  },

  mounted: function () {
    this.$nextTick(function () {
      this.player = videojs('mainvideo', this.videoData)
      if (this.reportStateFrequency > 0) { // pass in false or 0 to turn off state reporting.
        this.intervalLogger = setInterval(() => {
          if (this.player.waiting) {
            this.$emit('reportState', 'waiting')
          } else if (this.player.paused()) {
            this.$emit('reportState', 'paused')
          } else {
            this.$emit('reportState', 'playing')
          }
        }, this.reportStateFrequency * 1000)
      }
    })
  },

  data: () => {
    return {
      player: null,
      intervalReporter: null
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../node_modules/video.js/src/css/video-js";
@import "../../node_modules/video.js/src/css/vjs";
@import "../../node_modules/videojs-font/scss/videojs-icons";
</style>
